
export const stripeToken: stripe.Token = {
  id: 'tok_1BG6E6CChxYzY8x2qwa4ci1B',
  object: 'token',
  card: {
    id: 'card_1BG6E6CChxYzY8x2wXB5WnrC',
    object: 'card',
    address_city: 'Montreal',
    address_country: 'CA',
    address_line1: '4015, rue Drolet',
    address_line1_check: 'unchecked',
    address_state: 'CA-QC',
    address_zip: 'H2W 2L3',
    address_zip_check: 'unchecked',
    brand: 'Visa',
    country: 'CA',
    cvc_check: 'unchecked',
    dynamic_last4: '',
    exp_month: 9,
    exp_year: 2019,
    fingerprint: '',
    funding: 'credit',
    last4: '4033',
    metadata: {},
    name: 'Simon Chevalier',
    tokenization_method: undefined,
  },
  client_ip: '66.11.43.114',
  created: 1508766262,
  livemode: false,
  type: 'card',
  used: false,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/tests/mocks/stripeTokenMock.ts